import script from "./SocialFundCommunicationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFundCommunicationDialog.vue?vue&type=script&setup=true&lang=js"

import "./SocialFundCommunicationDialog.vue?vue&type=style&index=0&id=68145f08&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68145f08"]])

export default __exports__